export default "__VITE_ASSET__UDUG72pb__"